import React, { useEffect, useState } from "react";
import { Profession, ProfessionListProps } from "./ProfessionList.types";
import { useForm } from "react-hook-form";
import "./ProfessionList.css";

const ApiUriSearch: string = process.env.REACT_APP_PROGRAM_SEARCH_API || "";
const ApiKeySearch: string = process.env.REACT_APP_PROGRAM_SEARCH_API_KEY || "";

const ProfessionList = (props: ProfessionListProps) => {
    const [professions, setProfessions] = useState<Profession[]>();

    const { handleSubmit, register, setValue, reset, watch } = useForm<{ addOnTracks: number[]; concentrations: number[]; levels: number[]; prof: number[] }>();
    const profs = watch('prof');

    useEffect(() => {
        let isCancelled = false;
        const getProfessions = () => {
            fetch(`${ApiUriSearch}/api/professions?code=${ApiKeySearch}`)
                .then((res) => res.json())
                .then((response) => {
                    if (!isCancelled) {
                        setProfessions(response);
                        props.selectedProfessions.forEach((profId) => {
                            setValue(`prof[${profId}]`, true);
                        });

                        props.selectedConcentrations.forEach((conId) => {
                            setValue(`concentrations[${conId}]`, true);
                        })

                        props.selectedAddOnTracks.forEach((addOnId) => {
                            setValue(`addOnTracks[${addOnId}]`, true);
                        })
                        props.selectedLevels.forEach((levelId) => {
                            setValue(`levels[${levelId}]`, true);
                        })
                    }
                });
        };

        getProfessions();

        return () => {
            isCancelled = true;
        };
    }, [setProfessions, props.selectedProfessions, setValue]);

    const submitProfessions = (formData) => {
        props.onSubmit({
            professions: formData.prof
                .filter((x) => x !== false)
                ?.map((y) => +y),
            concentrations: formData.concentrations
                .filter((x) => x !== false)
                ?.map((y) => +y),
            addOnTracks: formData.addOnTracks
                .filter((x) => x !== false)
                ?.map((y) => +y),
            levels: formData.levels
                .filter((x) => x !== false)
                ?.map((y) => +y),
        });
    };

    const concentrationCheckChange = (changeEvent) => {
        if (changeEvent.target.checked) {
            const selectedProfession = professions?.filter(
                x => x.concentrations.map(con => con.concentrationId).indexOf(+changeEvent.target.value) >= 0
            );
            if (selectedProfession) {
                const profName = `prof[${selectedProfession[0].professionId}]`;
                setValue(profName, true);
            }
        }
    }

    const addOnTrackCheckChange = (changeEvent) => {
        if (changeEvent.target.checked) {
            const selectedProfession = professions?.filter(
                x => x.addOnTracks.map(addon => addon.addOnTrackId).indexOf(+changeEvent.target.value) >= 0
            );
            if (selectedProfession) {
                const profName = `prof[${selectedProfession[0].professionId}]`;
                setValue(profName, true);
            }
        }
    }

    const levelCheckChange = (changeEvent) => {
        if (changeEvent.target.checked) {
            const selectedProfession = professions?.filter(
                x => x.levels.map(level => level.id).indexOf(+changeEvent.target.value) >= 0
            );
            if (selectedProfession) {
                const profName = `prof[${selectedProfession[0].professionId}]`;
                setValue(profName, true);
            }
        }
    }

    const professionChange = (changeEvent) => {
        if (changeEvent.target.checked) {
            const selectedProfs = professions?.filter(
                (x) => x.professionId === +changeEvent.target.value
            );
            if (selectedProfs) {
                selectedProfs[0].concentrations.forEach((x) => {
                    const conName = `concentrations[${x.concentrationId}]`;
                    setValue(conName, true);
                });
                selectedProfs[0].addOnTracks.forEach((x) => {
                    const addOnName = `addOnTracks[${x.addOnTrackId}]`;
                    setValue(addOnName, true);
                });
                selectedProfs[0].levels.forEach((x) => {
                    const levelName = `levels[${x.id}]`;
                    setValue(levelName, true);
                });
            }
        } else {
            const selectedProfs = professions?.filter(
                (x) => x.professionId === +changeEvent.target.value
            );
            if (selectedProfs) {
                selectedProfs[0].concentrations.forEach((x) => {
                    const conName = `concentrations[${x.concentrationId}]`;
                    setValue(conName, false);
                });
                selectedProfs[0].addOnTracks.forEach((x) => {
                    const addOnName = `addOnTracks[${x.addOnTrackId}]`;
                    setValue(addOnName, false);
                });
                selectedProfs[0].levels.forEach((x) => {
                    const levelName = `levels[${x.id}]`;
                    setValue(levelName, false);
                });
            }
        }
    };

    return (
        <form onSubmit={handleSubmit(submitProfessions)}>
            {professions &&
                professions.map((prof: Profession) => {
                    return (
                        <div key={prof.professionId}>
                            <div className="form-group">
                                <div>
                                    <label
                                        htmlFor={`prof[${prof.professionId}]`}
                                    >
                                        {prof.title}
                                    </label>
                                </div>
                                <div>
                                    <label className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            name={`prof[${prof.professionId}]`}
                                            ref={register()}
                                            value={prof.professionId}
                                            onChange={professionChange}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            {prof.concentrations.length > 0 && (
                                <>
                                    <div className={`expandable ${(!!profs && !!profs[prof.professionId]) ? `expanded` : ``}`}>
                                        <div className="sub-section indent">
                                            Concentrations
                                        </div>
                                        {prof.concentrations.map(
                                            (concentration) => (
                                                <div
                                                    key={
                                                        concentration.concentrationId
                                                    }
                                                    className="form-group indent"
                                                >
                                                    <div>
                                                        <label
                                                            htmlFor={`concentrations[${concentration.concentrationId}]`}
                                                        >
                                                            {concentration.title}
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="checkbox-container">
                                                            <input
                                                                type="checkbox"
                                                                name={`concentrations[${concentration.concentrationId}]`}
                                                                ref={register()}
                                                                value={
                                                                    concentration.concentrationId
                                                                }
                                                                onChange={concentrationCheckChange}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </>
                            )}
                            {prof.addOnTracks.length > 0 && (
                                <>
                                    <div className={`expandable ${(!!profs && !!profs[prof.professionId]) ? `expanded` : ``}`}>
                                        <div className="sub-section indent">
                                            Add-on Tracks
                                        </div>
                                        {prof.addOnTracks.map((addOnTrack) => (
                                            <div
                                                key={addOnTrack.addOnTrackId}
                                                className="form-group indent"
                                            >
                                                <div>
                                                    <label
                                                        htmlFor={`addOnTracks[${addOnTrack.addOnTrackId}]`}
                                                    >
                                                        {addOnTrack.title}
                                                    </label>
                                                </div>
                                                <div>
                                                    <label className="checkbox-container">
                                                        <input
                                                            type="checkbox"
                                                            name={`addOnTracks[${addOnTrack.addOnTrackId}]`}
                                                            ref={register()}
                                                            value={
                                                                addOnTrack.addOnTrackId
                                                            }
                                                            onChange={addOnTrackCheckChange}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                            {prof.levels.length > 0 && (
                                <>
                                    <div className={`expandable ${(!!profs && !!profs[prof.professionId]) ? `expanded` : ``}`}>
                                        <div className="sub-section indent">
                                            Levels
                                        </div>
                                        {prof.levels.map((levels) => (
                                            <div
                                                key={levels.id}
                                                className="form-group indent"
                                            >
                                                <div>
                                                    <label
                                                        htmlFor={`levels[${levels.id}]`}
                                                    >
                                                        {levels.title}
                                                    </label>
                                                </div>
                                                <div>
                                                    <label className="checkbox-container">
                                                        <input
                                                            type="checkbox"
                                                            name={`levels[${levels.id}]`}
                                                            ref={register()}
                                                            value={
                                                                levels.id
                                                            }
                                                            onChange={levelCheckChange}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            <div className="button-footer">
                <div>
                    <button
                        type="button"
                        className="clear-btn"
                        onClick={() => reset()}
                    >
                        Clear All
                    </button>
                </div>
                <div>
                    <button type="submit" className="submit-btn">
                        Search
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ProfessionList;
